import * as ReactDOM from "react-dom";
import * as React from "react";

import { Provider } from "react-redux";
import {
    HashRouter,
    Route,
    Switch,
} from "react-router-dom";
import thunk from "redux-thunk";
import { createStore, applyMiddleware } from "redux";
import reducers from "./reducers";

import { USER_LOGIN, USER_LOGOUT } from "./reducers/auth";
import Axios from "axios";
import Navbar from "./components/Navbar";
import NotFound from "./pages/NotFound";
import Home from "./pages/Home";
import blacklist from "./pages/Blacklist";
import holders from "./pages/Holders";
import objects from "./pages/Objects";
import producers from "./pages/Producers";
import groups from "./pages/Groups";
import moderators from "./pages/Moderators";
import requests from "./pages/Requests";
import settings from "./pages/Settings";
import nosorted from "./pages/NoSorted";
import Questions from "./pages/Questions";
import Login from "./pages/Login";
import { ToastContainer } from "react-toastify";

import 'react-toastify/dist/ReactToastify.css';
import SingleObject from "./pages/SingleObject";
import SingleGroup from "./pages/SingleGroup";
import Holder from "./pages/Holder";
import Transactions from "./pages/Transactions";
import RequestsSMS from "./pages/RequestsSMS";
import RequestsActivate from "./pages/RequestsActivate";
import RequestsMusic from "./pages/RequestsMusic";
import RequestsProducer from "./pages/RequestsProducer";
import RequestsChanges from "./pages/RequestsChanges";
import RequestsObjects from "./pages/RequestsObjects";
import Reports from "./pages/Reports";
import Payments from "./pages/Payments";
import SavedPayments from "./pages/SavedPayments";
import CreatePayments from "./pages/CreatePayments";
import { ADD_IDS } from "./reducers/payment";
import Question from "./pages/Question";
import Splitter from "./pages/Splitter";
import Main from "./pages/user/Main";
import UserNavbar from "./components/UserNavbar";
import Compositions from "./pages/user/Compositions";
import Tickets from "./pages/user/Tickets";
import Ticket from "./pages/user/Ticket";
import Preferences from "./pages/user/Preferences";
import { CHANGE } from "./reducers/search";
import Balance from "./pages/user/Balance";
import ProducerHolders from "./pages/producer/ProducerHolders";
import ProducerHolder from "./pages/producer/ProducerHolder";
import ProducerTransactions from "./pages/producer/ProducerTransactions";
import ProducerNavbar from "./components/ProducerNavbar";
import ProducerObjects from "./pages/producer/ProducerObjects";
import ProducerTickets from "./pages/producer/ProducerTickets";
import ProducerTicket from "./pages/producer/ProducerTicket";
import AdminRoute from "./utils/AdminRoute";
import UserRoute from "./utils/UserRoute";
import ProducerRoute from "./utils/ProducerRoute";
import MultipleObjects from "./pages/MultipleObjects";
import RequestsCompositionChange from "./pages/RequestsCompositionChange";

import * as history from 'history';
import ArchiveHolders from "./pages/ArchiveHolders";
import ArchiveHolder from "./pages/ArchiveHolder";
import ArchiveTransactions from "./pages/ArchiveTransactions";
import ArchiveObjects from "./pages/ArchiveObjects";
import ObjectReport from "./pages/ObjectReport";
import Dopdoxods from "./pages/Dopdoxods";

const h = history.createBrowserHistory();

declare global {
    interface JQuery {
        datepicker: any,
        select2: any
    }
}

h.listen((location, action) => {
    store.dispatch({
        type: CHANGE,
        payload: "",
    });
});

const store = createStore(reducers, applyMiddleware(thunk));

// store.subscribe(() => {
//     console.log(store.getState());
// })

let token = localStorage.getItem("token");
let userString = localStorage.getItem("user");

if (token && userString) {
    Axios.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            if (error.response)
                if (error.response.status === 401) {
                    localStorage.removeItem("token");
                    localStorage.removeItem("user");
                    store.dispatch({
                        type: USER_LOGOUT,
                        user: JSON.parse(userString),
                    });
                } else {
                    return Promise.reject(error);
                }
        }
    );

    Axios.defaults.headers.common["Authorization"] = "Bearer " + token;

    store.dispatch({
        type: USER_LOGIN,
        user: JSON.parse(userString),
    });
}

let ids = localStorage.getItem("ids");

if (ids) {
    store.dispatch({
        type: ADD_IDS,
        payload: JSON.parse(ids),
    });
}

ReactDOM.render(
    <Provider store={store}>
        <HashRouter>
            <div>
                <ToastContainer />
                <Route render={(props: any) => {
                    let { location } = props;

                    return location.pathname == "/login" ? null : (location.pathname.startsWith("/admin") ? <Navbar {...props} /> : location.pathname.startsWith("/producer") ? <ProducerNavbar {...props} /> : <UserNavbar {...props} />);
                }} />
                <Switch>
                    <Route path="/" exact component={Splitter} />
                    <Route path="/login" exact component={Login} />

                    <AdminRoute path="/admin" exact component={Home} />
                    <AdminRoute path="/admin/holders" exact component={holders} />
                    <AdminRoute path="/admin/holders/:id" exact component={holders} />
                    <AdminRoute path="/admin/holder/:id" exact component={Holder} />
                    <AdminRoute path="/admin/transactions/:id" exact component={Transactions} />
                    <AdminRoute path="/admin/producers" exact component={producers} />
                    <AdminRoute path="/admin/objects" exact component={objects} />
                    <AdminRoute path="/admin/object" exact component={SingleObject} />
                    <AdminRoute path="/admin/object/report/:id" exact component={ObjectReport} />
                    <AdminRoute path="/admin/object/update/:ids" exact component={(props: any) => <MultipleObjects {...props} isMulti={true} />} />
                    <AdminRoute path="/admin/object/update2/:ids" exact component={(props: any) => <MultipleObjects {...props} isMulti={false} />} />
                    <AdminRoute path="/admin/object/:id" exact component={SingleObject} />
                    <AdminRoute path="/admin/groups" exact component={groups} />
                    <AdminRoute path="/admin/group/:id" exact component={SingleGroup} />
                    <AdminRoute path="/admin/group" exact component={SingleGroup} />
                    <AdminRoute path="/admin/moderators" exact component={moderators} />
                    <AdminRoute path="/admin/requests" exact component={requests} />
                    <AdminRoute path="/admin/requests/sms" exact component={RequestsSMS} />
                    <AdminRoute path="/admin/requests/activate" exact component={RequestsActivate} />
                    <AdminRoute path="/admin/requests/music" exact component={RequestsMusic} />
                    <AdminRoute path="/admin/requests/producer" exact component={RequestsProducer} />
                    <AdminRoute path="/admin/requests/change" exact component={RequestsChanges} />
                    <AdminRoute path="/admin/requests/composition-change" exact component={RequestsCompositionChange} />
                    <AdminRoute path="/admin/requests/object" exact component={RequestsObjects} />
                    <AdminRoute path="/admin/settings" exact component={settings} />
                    <AdminRoute path="/admin/no-sorted" exact component={nosorted} />
                    <AdminRoute path="/admin/black-list" exact component={blacklist} />
                    <AdminRoute path="/admin/questions" exact component={Questions} />
                    <AdminRoute path="/admin/question/:id" exact component={Question} />
                    <AdminRoute path="/admin/reports" exact component={Reports} />
                    <AdminRoute path="/admin/reports/payment" exact component={Payments} />
                    <AdminRoute path="/admin/reports/saved" exact component={SavedPayments} />
                    <AdminRoute path="/admin/reports/dopdoxod" exact component={Dopdoxods} />
                    <AdminRoute path="/admin/create-payments" exact component={CreatePayments} />
                    <AdminRoute path="/admin/restore-payments/:id" exact component={CreatePayments} />

                    <AdminRoute path="/admin/archive/holders" exact component={ArchiveHolders} />
                    <AdminRoute path="/admin/archive/holder/:id" exact component={ArchiveHolder} />
                    <AdminRoute path="/admin/archive/transactions/:id" exact component={ArchiveTransactions} />
                    <AdminRoute path="/admin/archive/objects" exact component={ArchiveObjects} />

                    <UserRoute path="/user" exact component={Main} />
                    <UserRoute path="/user/objects" exact component={Compositions} />
                    <UserRoute path="/user/tickets" exact component={Tickets} />
                    <UserRoute path="/user/ticket/:id" exact component={Ticket} />
                    <UserRoute path="/user/settings" exact component={Preferences} />
                    <UserRoute path="/user/history" exact component={Balance} />

                    <ProducerRoute path="/producer" exact component={ProducerHolders} />
                    <ProducerRoute path="/producer/holder/:id" exact component={ProducerHolder} />
                    <ProducerRoute path="/producer/transactions/:id" exact component={ProducerTransactions} />
                    <ProducerRoute path="/producer/objects" exact component={ProducerObjects} />
                    <ProducerRoute path="/producer/tickets" exact component={ProducerTickets} />
                    <ProducerRoute path="/producer/ticket/:id" exact component={ProducerTicket} />
                    <ProducerRoute path="/producer/settings" exact component={Preferences} />

                    <NotFound />
                </Switch>
                {/* <Footer /> */}
            </div>
        </HashRouter>
    </Provider>,
    document.getElementById("root")
);
